import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "../apiClient";

// API call to post retake attendances
export const postRetakeAttendances = ({ data }) => {
  return api.post("/admin/retake-schedule", data);
};

// Hook for posting retake attendances
export const usePostRetakeAttendance = ({ mutationConfig } = {}) => {
  const queryClient = useQueryClient();
  const { onSuccess, ...restConfig } = mutationConfig || {};

  return useMutation({
    mutationFn: postRetakeAttendances,
    onSuccess: async (data, ...args) => {
      if (onSuccess) {
        await onSuccess(data, ...args);
      }
      queryClient.resetQueries();
    },
    ...restConfig,
  });
};
